import React from "react";
import TempleGridValues from "./TempleGridValues/TempleGridValues";
import TgridHowtoPosts from "../documentation/TempleGridUserDocs/TempleGridPostDocs/TgridHowtoPosts";
import TempleGridFlexInformation from "../documentation/TempleGridUserDocs/TempleGridFlexInfo/TempleGridFlexInformation";

const TempleGridDocsHome = () => {
  return (
    <div>
      <div>
        <TempleGridValues />
        <TgridHowtoPosts />
        <TempleGridFlexInformation />
      </div>
    </div>
  );
};

export default TempleGridDocsHome;
